import { useSelector } from 'react-redux'
import { SentimentCell } from '../../../../common/news/SentimentCell'
import { selectRecentNewsById } from '../../store/slice'

export const Sentiment = ({ rowId }) => {
  const sentimentName = useSelector(selectRecentNewsById(rowId, 'newsTypeName'))
  const newsTypeIds = useSelector(selectRecentNewsById(rowId, 'newsTypeIds'))

  return (
    <SentimentCell sentimentName={sentimentName} newsTypeIds={newsTypeIds} />
  )
}
